const perusahaan = () => import(/* webpackPrefetch: true */ '@/views/private/master/perusahaan/index.vue')

const unit = () => import(/* webpackPrefetch: true */ '@/views/private/master/unit/index.vue')

const import_anggaran = () => import(/* webpackPrefetch: true */ '@/views/private/master/import-anggaran/index.vue')

const informasi_unit = () => import(/* webpackPrefetch: true */ '@/views/private/master/informasi-unit/index.vue')

const document = () => import(/* webpackPrefetch: true */ '@/views/private/master/document/index.vue')

const routes = [
  {
    path: "/master/perusahaan",
    name: "Perusahaan / OPD",
    component: perusahaan,
    meta: {
      title: "Perusahaan / OPD"
    }
  },

  {
    path: "/master/unit",
    name: "Unit",
    component: unit,
    meta: {
      title: "Unit"
    }
  },

  {
    path: "/master/import-anggaran",
    name: "Import Anggaran",
    component: import_anggaran,
    meta: {
      title: "Import Anggaran"
    }
  },

  {
    path: "/master/informasi-unit",
    name: "Informasi Unit",
    component: informasi_unit,
    meta: {
      title: "Informasi Unit"
    }
  },


  {
    path: "/master/document",
    name: "Data Document",
    component: document,
    meta: {
      title: "Data Document"
    }
  },
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})